import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

function CopyableValue({ label, value }) {
  const handleCopy = () => {
    if (value) navigator.clipboard.writeText(value)
  }
  return (
    <Box sx={{ mb: 1.5 }}>
      <Typography sx={{ fontSize: '0.72rem', fontFamily: 'AtlasGroteskRegular', color: '#888', fontWeight: 600, mb: 0.25 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626' }}>
          {value || '—'}
        </Typography>
        {value && (
          <Tooltip title='Copy'>
            <IconButton size='small' onClick={handleCopy} sx={{ p: 0.25 }}>
              <ContentCopyIcon sx={{ fontSize: 13, color: '#bbb' }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  )
}
CopyableValue.propTypes = { label: PropTypes.string.isRequired, value: PropTypes.string }

function BillingDetailsCardV2({ orderDetail }) {
  if (!orderDetail) return null
  return (
    <Box sx={{
      border: '1px solid #e7e7e7',
      borderRadius: 2,
      p: 2.5,
      backgroundColor: '#fff',
      height: '100%',
    }}>
      <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '0.95rem', color: '#262626', fontWeight: 700, mb: 2 }}>
        Billing Details
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1 }}>
        <Box>
          <CopyableValue label='Bill-to Name' value={orderDetail.billToName} />
          <CopyableValue label='' value={orderDetail.billToAccountNumber} />
        </Box>
        <Box>
          <CopyableValue label='Contact' value={orderDetail.contactPhone} />
          <CopyableValue label='' value={orderDetail.contactEmail} />
        </Box>
      </Box>
      <Box sx={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 1, mt: 0.5 }}>
        <Box>
          <Typography sx={{ fontSize: '0.72rem', fontFamily: 'AtlasGroteskRegular', color: '#888', fontWeight: 600, mb: 0.25 }}>
            Bill-to Address
          </Typography>
          <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626' }}>
            {orderDetail.billToAddress || '—'}
          </Typography>
        </Box>
        <CopyableValue label='Payment Terms' value={orderDetail.paymentTerms} />
      </Box>
    </Box>
  )
}

BillingDetailsCardV2.propTypes = { orderDetail: PropTypes.object }

export default BillingDetailsCardV2
